/**
 * 产业链数据Hook
 * 使用React Query管理产业链数据获取
 */
import { useQuery } from '@tanstack/react-query';
import { industryApi } from '../api';
// 引入类型，确保路径正确
import type { ProductionData, SupplyDemandData, TradeRoute } from '../types';

// 获取产量数据 (修复: 统一为一个函数，并支持参数)
export const useProductionData = (params?: any) => {
  return useQuery({
    queryKey: ['production', params],
    queryFn: () => industryApi.getProductionData(params),
  });
};

// 获取贸易路线
export const useTradeRoutes = (params?: any) => {
  return useQuery({
    queryKey: ['trade-routes', params],
    queryFn: () => industryApi.getTradeRoutes(params),
  });
};

// 获取供需数据 (修复: 增加 params 参数，解决 Expected 0 arguments 报错)
export const useSupplyDemandData = (params?: any) => {
  return useQuery({
    queryKey: ['supply-demand', params],
    queryFn: () => industryApi.getSupplyDemandData(params),
  });
};

export const useIndustryChain = () => {
  return useQuery({
    queryKey: ['industry-chain'],
    queryFn: async () => {
      const response: any = await industryApi.getIndustryChain();
      // 后端现在返回 { nodes, edges, layers } 结构，直接使用
      return response;
    },
  });
};